// package dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class GuestsHeader extends Component { // eslint-disable-line
  render() {
    const { checkAllRows, checkedAllRows, onToggleSort, sortByNameAsc, style } = this.props;

    return (
      <thead className="table-header" style={style}>
        <tr>
          <th className="td-checkbox">
            <div className="checkbox checkbox-table">
              <label htmlFor="guests-select-all">
                <input
                  type="checkbox"
                  id="guests-select-all"
                  onClick={checkAllRows}
                  checked={checkedAllRows}
                  readOnly
                />
                <span className="input-override"><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Select all guests on this page."><i className="zolaicon zolaicon-checkmark" /></div></span>
              </label>
            </div>
          </th>
          <th className="sortable" role="button" onClick={onToggleSort} ><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View guests by last name, ascending or descending."><span className="tooltip-span">Name<i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></span></div></th>
          <th><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Total guests in party"><span className="tooltip-span">NO.</span></div></th>
          <th>Email &amp; Mobile</th>
          <th>Mailing Address</th>
          <th><div className="with-tooltip" data-tooltip="Tame your guest list with these filters by marking who's &quot;Definitely&quot; and &quot;Maybe&quot; invited."><span className="tooltip-span">Invited?</span><i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline" /></div></th>
          <th>&nbsp;</th>
        </tr>
      </thead>
    );
  }
}

GuestsHeader.defaults = {
  style: {}
};

GuestsHeader.propTypes = {
  checkAllRows: PropTypes.func.isRequired,
  checkedAllRows: PropTypes.bool.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  style: PropTypes.objectOf(PropTypes.string)
};

export default GuestsHeader;




// WEBPACK FOOTER //
// ./src/components/manage/guestlist/directoryEntities/GuestsHeader.jsx